module.exports = __webpack_public_path__ + "img/home.657046a0.jpg";